import { useInfiniteQuery } from '@tanstack/react-query';
import axiosClient from 'libs/axios/axios';

import { snakeToCamel } from 'util/snakeToCamel';

interface IGetParicipantListParams {
  pageParam: number;
  pageSize?: number;
  keyword?: string;
}

const getParticipantList = async (values: IGetParicipantListParams) => {
  const { pageParam, pageSize = 10, keyword = '' } = values;

  const { data } = await axiosClient.get(
    `/tbm/participant?page_num=${pageParam}&page_size=${pageSize}&keyword=${keyword}`,
  );

  return {
    result: snakeToCamel(data.data),
    nextPage: pageParam + 1,
    isLast: !!data.next,
  };
};

const useGetParticipantListQuery = (keyword?: string) =>
  useInfiniteQuery(
    ['participant', 'list', keyword],
    ({ pageParam = 1 }) => getParticipantList({ pageParam, keyword }),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.isLast) return lastPage.nextPage;
        return undefined;
      },
      onError: (error) => {
        console.error('get participant list error', error);
      },
    },
  );

export default useGetParticipantListQuery;
